import { render, staticRenderFns } from "./BrowserContentMetadata.vue?vue&type=template&id=2342ca7e"
import script from "./BrowserContentMetadata.vue?vue&type=script&lang=js"
export * from "./BrowserContentMetadata.vue?vue&type=script&lang=js"
import style0 from "./BrowserContentMetadata.vue?vue&type=style&index=0&id=2342ca7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports